import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {clickedControl} from '../edap';

import {withTranslationsAsProps} from '../../../components/translations';
import createTripboardActions from '../actions';
import {ADD_CIRCLE__24} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';

import './create-tripboard-card.less';
export const EDAP_LABEL = 'tripboard.create.control.card';

const handleClick = (callback) => () => {
    /* dispatch edap */
    clickedControl(EDAP_LABEL);
    callback();
};

export const CreateTripboardCard = ({title, openModal}) => {
    const onClick = handleClick(openModal);
    return (
        <div className="tripboard-summary-container__hit-wrapper" role="button" aria-label={title} onKeyDown={onClick} tabIndex={0} onClick={onClick}>
            <div className="create-tripboard-card card">
                <div className="create-tripboard-card__title"><h3>{title}</h3></div>
                <div className="create-tripboard-card__content">
                    <div className="create-tripboard-card__cta">
                        <div className="create-tripboard-card__icon">
                            <SVGIcon strokeWidth={1} markup={ADD_CIRCLE__24} />
                        </div>
                    </div>
                </div>
                <div className="create-tripboard-card__bottom" />
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    openModal: createTripboardActions.openModal
};

export default compose(withTranslationsAsProps({'tripboards.modal.create.new.list.copy': 'title'}), connect(null, mapDispatchToProps))(CreateTripboardCard);



// WEBPACK FOOTER //
// ./src/universal/tripboard/create-tripboard-controls/components/create-tripboard-card.js